module.exports = __webpack_public_path__ + "static/media/house3.aa171e89.png";